//general methods
import moment from 'moment';
import { sep } from 'path';
export default {
    data() {
        return {
        }
    },
    methods: {
        copyToClipBoard(text) {
            var el = document.createElement("textarea");
            el.value = text;
            // Set non-editable to avoid focus and move outside of view
            el.setAttribute("readonly", "");
            el.style = { position: "absolute", left: "-9999px" };
            document.body.appendChild(el);
            // Select text inside element
            el.select();
            // Copy text to clipboard
            document.execCommand("copy");
            // Remove temporary element
            document.body.removeChild(el);
        },
        convertCurrencyToSymbol(currency) {
            switch (currency) {
                case 'EUR':
                    return "€"
                case 'USD':
                    return '$'
                default:
                    return currency
            }
        },
        hasUserRight(rightToCheck) {
            return this.$store.getters.USERPROFILE[rightToCheck]
        },
        /* Transform the temp date to a date comprehensible by server */
        convertDateAndHourToIsoFrLocale(date, hour, type) {
            if (date && !hour) {
                if (type == "start")
                    return moment(Date.parse(date + " " + "00:00")).locale('fr').utc();
                else
                    return moment(Date.parse(date + " " + "23:59")).locale('fr').utc();
            } else if (date && hour) {
                return moment(Date.parse(date + " " + hour)).locale('fr').utc();
            }
        },
        /* Transform the temp date to a date comprehensible by server */
        convertDateAndHourToIsoFrLocale2(date, hour, type) {
            //define locale TZ in france
            moment.locale('fr')
            if (date && !hour) {
                if (type == "start")
                    return moment(Date.parse(date + " " + "00:00")).format();
                else
                    return moment(Date.parse(date + " " + "23:59")).format();
            } else if (date && hour) {
                return moment(Date.parse(date + " " + hour)).format();
            }
        },
        convertIsoFrLocaleToDateAndHour(dateIso) {
            var result = {};
            if (dateIso) {
                var momentObj = moment(dateIso)
                result.date =
                    momentObj.format('YYYY') + "-" + momentObj.format('MM') + "-" + momentObj.format('DD');
                result.hour =
                    momentObj.format('HH') + ":" + momentObj.format('mm');
            }
            return result;
        },
        /* 
        Export Informations from flag(coupon_history or campaign_info or coupon_code) to CSV
         */
        exportGlobalInfosCSV(flag, campaign, discountsList, couponUseList, couponTable) {
            if (flag) {
                var csv = "";
                var separator = ";";
                var hiddenElement = document.createElement("a");
                switch (flag) {
                    case "coupon_history"://historique coupon
                        csv = "Campaign name"+separator+ "Code du coupon"+separator+"Date"+separator+ "Réduction"+separator+"Statut"+separator+ "Identifiant transaction"+separator +"Indentifiant client"+separator +"Récupéré par\n"
                        couponUseList.forEach(couponuse => {
                            csv += campaign.name;
                            csv +=separator;
                            csv += couponuse["coupon-value"];
                            csv += separator;
                            csv += moment(couponuse['transaction-date']).format(`DD/MM/YYYY - HH:mm`);
                            csv += separator;
                            csv += '-' + (couponuse['applied-discount'] != 0 ? (couponuse['applied-discount'] / 100).toFixed(2) + this.convertCurrencyToSymbol(couponuse['discount-currency']) : "-") + " " + couponuse['product-name'] | couponuse['sales-channel-name'];
                            csv += separator;
                            csv += (couponuse['transaction-status'] == 0 ? "Annulé" : couponuse['transaction-status'] == 1 ? "Récupéré" : couponuse['transaction-status'] == 2 ? "En cours" : couponuse['transaction-status'] == 3 ? "En cours" : couponuse['transaction-status'] == 4 ? "Utilisé" : "");
                            csv += separator;
                            csv += couponuse['merchant-order-id'];
                            csv += separator;
                            csv += couponuse['merchant-reference'];
                            csv += separator;
                            csv +=  couponuse['retriever-first-name'] ? couponuse['retriever-first-name'] + " " + couponuse['retriever-name'] + " " + "(" + couponuse['retriever-company'] + ")" : " - ";
                            csv += "\n";
                        });
                        hiddenElement.download = "campaign-" + campaign.name + "-couponHistory.csv";

                        break;
                    case "campaign_info": //info sur la campagne
                        csv = "Campaign name"+separator +"Start date"+separator +"End date"+separator+ "Number of coupons\n"
                        csv += campaign.name
                        csv += separator;
                        csv += moment(campaign['start-date']).format(`DD/MM/YYYY - HH:mm`)
                        csv += separator;
                        csv += moment(campaign['expiration-date']).format(`DD/MM/YYYY - HH:mm`)
                        csv += separator;
                        csv += campaign['max-number-of-coupons']
                        csv += separator;
                        csv += "\n";
                        csv += "Product name"+separator+"Sales Channel"+separator+"Merchant Name"+separator+ "Number of used coupons"+separator+ "Total applied discount\n";
                        //info sur les discounts
                        var totalCoupon = 0
                        var totalDiscount = 0
                        console.log(discountsList) // TO_DO remove
                        discountsList.forEach(row => {
                            csv += row["product-name"];
                            csv +=separator;
                            csv += row["sales-channel-name"];
                            csv += separator;
                            csv += row["sales-channel-merchant-name"];
                            csv += separator;
                            csv += row["number-of-used-coupons"];
                            csv += separator;
                            csv += row["total-sum-of-discounts"] / 100;
                            csv += " ";
                            csv += this.convertCurrencyToSymbol(row["discount-currency"]);
                            csv += "\n";
                            if (((row["total-sum-of-discounts"] / 100) / row["number-of-used-coupons"]) > 0) {
                                csv += "Total par Discount"+separator+separator+separator+separator + (row["number-of-used-coupons"]) + " de " + ((row["total-sum-of-discounts"] / 100) / row["number-of-used-coupons"]).toFixed(2) + " " + this.convertCurrencyToSymbol(row["discount-currency"]);
                                csv += "\n";
                            }
                            totalDiscount += row["total-sum-of-discounts"] / 100;
                            totalCoupon += row["number-of-used-coupons"];
                        })
                        //grand total : totalCoupon ( de reduction ) 
                        csv += "Grand Total"+separator+separator+separator + totalCoupon + separator + totalDiscount.toFixed(2) +this.convertCurrencyToSymbol("EUR")+ "\n"
                        hiddenElement.download =
                            "campaign-" + campaign.name + "-summary.csv";
                        break;
                    case "coupon_code"://Codes coupons
                        
                        csv = "Coupon"+separator+"Groupe\n";
                                couponTable.forEach(row => {
                                    csv += row.value;
                                    csv +=separator;
                                    csv += row["group-of-discounts-name"];
                                    csv += "\n";
                                });
                        hiddenElement.download =
                        "campaign-" + campaign.name + "-codescoupon.csv";
                        break;
                    default:
                        break;
                }
                
                if (navigator.msSaveBlob) { // IE 10+
                    var blob = new Blob(["\uFEFF",csv], { type: 'text/csv;charset=UTF-8;' });
                    navigator.msSaveBlob(blob,  hiddenElement.download);
                    return;
                }
                hiddenElement.href = "data:text/csv;charset=UTF-8," + '\uFEFF' + encodeURI(csv);
                hiddenElement.target = "_blank";
                console.log(hiddenElement)
                document.getElementById('app').appendChild(hiddenElement);
                hiddenElement.click();
            }
        }
    }

}